import axios from 'axios'
import * as errorAPI from '../error'
import router from '../router'
import store from '../store'

const Config = {
  baseUrl: '/u2lm-api/api/',
  headers: { 'content-type': 'application/json' }
}

function setErrorLog (id, password, err) {
  const url = err.config.url
  const parts = url.split('/')
  const fileName = parts[parts.length - 1]
  const message = err.message
  errorAPI.setLogSystemError(id, password, fileName, message)
}

// 응답을 가로채는 Interceptor를 등록합니다.
axios.interceptors.response.use(
  (response) => {
    // 응답이 성공적으로 도착한 경우
    if (response.data.hasOwnProperty('toLoginForm') && response.data.toLoginForm) {
      store.commit('userStore/mutatinResetUserINfo')
      router.push('/login')
    } else if (response.data.hasOwnProperty('openErrorDialog') && response.data.openErrorDialog) {
      store.commit('mutationIsOpenErrorDialog', true)
    }
    return response
  },
  (error) => {
    // 응답에 오류가 있는 경우
    if (error.response) {
      // setErrorLog(error.config.data.UserID, error.config.data.Password, error);
    } else if (error.request) {
      // 서버 응답이 도착하지 않은 경우
      console.log('No response received:', error.request)
    } else {
      // 기타 오류 처리
      console.log('Error:', error.message)
    }
    return Promise.reject(error)
  }
)

function callApi (path, payload, extraConfig = {}) {
  return axios.post(Config.baseUrl + path, payload, {
    headers: Config.headers,
    ...extraConfig
  }).catch(err => {
    setErrorLog(payload.userId, payload.password, err)
    throw err
  })
}
;

export {
  Config,
  setErrorLog,
  callApi
}
